<template>
    <div>
        <v-form-message
                id="form-success"
                :message="objectSuccess"
                type="success"
                :isVisible="objectSuccess !== null"
                :auto-close-timeout="autoCloseTimeout"/>
        <div class="dialog" :class="{ 'active' : isVisible }">
            <div class="dialog--content dialog--content-default">
                <h2>{{ getPageTitle }}</h2>
                <form action method="POST" novalidation @submit="onSubmitObject">
                    <div class="form-message form-message--error" v-if="objectError !== null">{{ objectError }}</div>

                    <div v-if="isUpdateMethod" class="form-group">
                        <div class="form-control form-control--static form-control--file">{{ object.file.name }}</div>
                    </div>
                    <div v-else class="form-group" :class="{ 'form-group--error' : $v.object.file.$error }">
                        <input
                                type="text"
                                name="file"
                                class="form-control form-control--file"
                                role="button"
                                :aria-label="$t('form.upload.file.plc')"
                                aria-controls="filename"
                                :placeholder="$t('form.upload.file.plc')"
                                v-model="$v.object.file.$model.name"
                                autocomplete="false"
                                readonly
                                @click="choseFiles"
                        />
                        <input
                                type="file"
                                name="file"
                                aria-hidden="true"
                                tabindex="-1"
                                class="form-control"
                                autocomplete="false"
                                ref="file"
                                @change="onChangeFile"
                        />
                    </div>
                    <div class="form-group">
            <textarea
                    v-show="commentIsVisible"
                    name="comment"
                    class="form-control form-control--textarea"
                    :placeholder="$t('form.upload.comment.plc')"
                    v-model="object.comment"
            ></textarea>
                    </div>
                    <div class="form-group">
                        <button
                                v-if="isUpdateMethod"
                                role="button"
                                type="submit"
                                class="button"
                                :title="$t('form.upload.update')"
                                :disabled="objectFormDisabled"
                        >{{ $t('form.upload.update') }}
                        </button>
                        <button
                                v-else
                                role="button"
                                type="submit"
                                class="button"
                                :title="$t('form.upload.create')"
                                :disabled="objectFormDisabled"
                        >{{ $t('form.upload.create') }}
                        </button>
                    </div>
                </form>
                <button class="close-button" @click="onClickAction('close')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import FormMessage from './Forms/FormMessage';

export default {
    components: {
        vFormMessage: FormMessage
    },
    props: {
        routes: {
            type: Object,
            default: () => ({
                upload: ''
            })
        },
        commentIsVisible: {
            type: Boolean,
            default: true
        },
        isVisible: {
            type: Boolean,
            default: false
        },
        method: {
            type: String,
            default: "create"
        },
        projectId: {
            type: [String, Number],
            required: true
        },
        value: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            objectError: null,
            objectFormDisabled: false,
            objectSuccess: null,
            autoCloseTimeout: 3000,
            object: {
                id: 0,
                file: {},
                comment: ""
            }
        };
    },
    watch: {
        value: {
            handler: function (newVal, oldVal) {
                this.object = {
                    id: newVal.id || 0,
                    file: newVal.file || {},
                    comment: newVal.comment || ""
                };
            },
            deep: true
        }
    },
    computed: {
        isCreateMethod: function () {
            return this.method === "create";
        },
        isUpdateMethod: function () {
            return this.method === "update";
        },
        getPageTitle: function () {
            return this.$t("form.upload." + this.method + ".title");
        }
    },
    validations: function () {
        return {
            object: {
                file: {
                    required,
                    isValidFile: value => {
                        if (value && value.name) {
                            return (
                                -1 !==
                                this.$helpers.uploads.indexOf(
                                    value.name
                                        .split(".")
                                        .pop()
                                        .toLowerCase()
                                )
                            );
                        }

                        return false;
                    }
                }
            }
        };
    },
    methods: {
        choseFiles: function () {
            let fileInputElement = this.$refs.file;
            fileInputElement.click();
        },
        onSubmitObject: function (event) {
            event.preventDefault();

            this.objectError = null;
            this.objectSuccess = null;
            this.objectFormDisabled = true;

            this.$v.object.$touch();

            if (this.$v.object.$invalid) {
                this.objectError = this.$t("form.error_form");
                this.objectFormDisabled = false;
            } else {
                this.object.project_id = parseInt(this.projectId);

                if (this.isCreateMethod) {
                    let promise = this.$api
                        .clearParams()
                        .post("internalfiles/create", this.$api.getFormData(this.object), {
                            headers: {
                                "Content-Type": "multipart/form-data"
                            }
                        });

                    promise
                        .then(
                            (response => {
                                this.objectError = "";
                                this.objectFormDisabled = false;
                                this.objectSuccess = this.$t('form.upload.create.success');
                                this.$emit("onAction", "upload", this.method, this.object);

                                this.onCloseDialog();
                            }).bind(this)
                        )
                        .catch(
                            (error => {
                                this.objectError = this.$t(error.response.data.message);
                                this.objectFormDisabled = false;
                            }).bind(this)
                        );
                } else {
                    let promise = this.$api
                        .clearParams()
                        .post(
                            "internalfiles/" + this.object.id + "/update",
                            this.$api.getFormData(this.object),
                            {
                                headers: {
                                    "Content-Type": "multipart/form-data"
                                }
                            }
                        );

                    promise
                        .then(
                            (response => {
                                this.objectError = "";
                                this.objectFormDisabled = false;

                                this.$emit("onAction", "upload", this.method, this.object);

                                this.onCloseDialog();
                            }).bind(this)
                        )
                        .catch(
                            (error => {
                                this.objectError = this.$t(error.response.data.message);
                                this.objectFormDisabled = false;
                            }).bind(this)
                        );
                }
            }
        },
        onChangeFile: function (value) {
            if (value.currentTarget.files[0]) {
                this.object.file = value.currentTarget.files[0];
            }
        },
        onOpenDialog: function () {
            this.isVisible = true;

            this.onResetDialog();
        },
        onCloseDialog: function () {
            this.isVisible = false;
            setTimeout((function () {
                this.onResetDialog();
            }).bind(this), this.autoCloseTimeout)
        },
        onResetDialog: function () {
            this.objectError = null;
            this.objectFormDisabled = false;
            this.object = {
                id: 0,
                file: {},
                comment: ""
            };

            this.$v.object.$reset();
        },
        onClickAction: function (action) {
            this.onCloseDialog();

            this.$emit("onAction", action, this.method);
        }
    }
};
</script>